(function () {
  'use strict';
  var qs = function (s, c) { return (c || document).querySelector(s); };
  var qsa = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = qs('[data-drawer]');
    var overlay = qs('.drawer-overlay');
    if (!drawer) return;
    function set(open) {
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (overlay) overlay.hidden = !open;
      document.body.style.overflow = open ? 'hidden' : '';
    }
    qsa('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { set(true); }); });
    qsa('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  /* ---------- Tabs (category tabs section) ---------- */
  function initTabs() {
    qsa('[data-tabs]').forEach(function (root) {
      var btns = qsa('[data-tab-btn]', root);
      var panels = qsa('[data-tab-panel]', root);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var id = btn.getAttribute('data-tab-btn');
          btns.forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          panels.forEach(function (p) {
            var on = p.getAttribute('data-tab-panel') === id;
            p.hidden = !on;
            p.classList.toggle('is-active', on);
          });
        });
      });
    });
  }

  /* ---------- Product page ---------- */
 
  /* ---------- Product page ---------- */

  function showSlide(root, index) {
    var slides = qsa('.gallery-slide', root);
    var thumbs = qsa('[data-thumb]', root);

    if (!slides.length) return;

    index = (index + slides.length) % slides.length;

    slides.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });

    thumbs.forEach(function (t, i) {
      var active = i === index;
      t.classList.toggle('is-active', active);

      if (active && t.scrollIntoView) {
        t.scrollIntoView({
          inline: 'center',
          block: 'nearest',
          behavior: 'smooth'
        });
      }
    });

    root.dataset.activeSlide = String(index);
  }

  /* ---------- Product gallery arrows + swipe ---------- */

  function initGalleryControls() {
  qsa('[data-product-section]').forEach(function (root) {
    var gallery = qs('.gallery-main', root);

    if (!gallery || gallery.dataset.swipeReady === '1') return;

    gallery.dataset.swipeReady = '1';

    // Cho phép vuốt ngang nhưng vẫn cuộn trang theo chiều dọc
    gallery.style.touchAction = 'pan-y';

    var startX = 0;
    var startY = 0;
    var isSwiping = false;
    var pointerId = null;

    // Nút ảnh trước / sau
    gallery.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-gallery-prev]');
      var next = e.target.closest('[data-gallery-next]');

      if (prev) {
        e.preventDefault();
        showSlide(root, getCurrentSlide(root) - 1);
      }

      if (next) {
        e.preventDefault();
        showSlide(root, getCurrentSlide(root) + 1);
      }
    });

    // Bắt đầu vuốt
    gallery.addEventListener('pointerdown', function (e) {
      // Bỏ qua click chuột phải
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      // Không bắt swipe khi người dùng bấm nút mũi tên
      if (e.target.closest('[data-gallery-prev], [data-gallery-next]')) {
        return;
      }

      startX = e.clientX;
      startY = e.clientY;
      pointerId = e.pointerId;
      isSwiping = true;

      try {
        gallery.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    // Kết thúc vuốt
    gallery.addEventListener('pointerup', function (e) {
      if (!isSwiping || e.pointerId !== pointerId) return;

      isSwiping = false;

      var deltaX = e.clientX - startX;
      var deltaY = e.clientY - startY;

      // Vuốt phải hoặc trái ít nhất 50px
      // Không nhận thao tác cuộn dọc
      if (
        Math.abs(deltaX) < 50 ||
        Math.abs(deltaX) < Math.abs(deltaY) * 1.2
      ) {
        return;
      }

      if (deltaX < 0) {
        // Vuốt sang trái -> ảnh tiếp theo
        showSlide(root, getCurrentSlide(root) + 1);
      } else {
        // Vuốt sang phải -> ảnh trước
        showSlide(root, getCurrentSlide(root) - 1);
      }
    });

    gallery.addEventListener('pointercancel', function () {
      isSwiping = false;
    });
  });
}

// Lấy chỉ số ảnh hiện tại
function getCurrentSlide(root) {
  var slides = qsa('.gallery-slide', root);

  var activeIndex = slides.findIndex(function (slide) {
    return slide.classList.contains('is-active');
  });

  return activeIndex >= 0 ? activeIndex : 0;
}

  function initProduct() {
    qsa('[data-product-section]').forEach(function (root) {
      qsa('[data-thumb]', root).forEach(function (t) {
        if (t.dataset.thumbReady === '1') return;
        t.dataset.thumbReady = '1';

        t.addEventListener('click', function () {
          showSlide(root, parseInt(t.getAttribute('data-thumb'), 10));
        });
      });

      var active = qsa('.gallery-slide', root).findIndex(function (s) {
        return s.classList.contains('is-active');
      });

      showSlide(root, active < 0 ? 0 : active);

      var qty = qs('input[name="quantity"]', root);
      var minus = qs('[data-qty-minus]', root);
      var plus = qs('[data-qty-plus]', root);

      if (qty && minus && plus && !qty.dataset.qtyReady) {
        qty.dataset.qtyReady = '1';

        minus.addEventListener('click', function () {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
        });

        plus.addEventListener('click', function () {
          qty.value = (parseInt(qty.value, 10) || 1) + 1;
        });
      }

      var json = qs('[data-product-json]', root);
      if (!json) return;

      var data;
      try {
        data = JSON.parse(json.textContent);
      } catch (e) {
        return;
      }

      var groups = qsa('[data-option-group]', root);
      if (!groups.length) return;

      var idInput = qs('[data-variant-id]', root);
      var btn = qs('[data-add-btn]', root);
      var price = qs('[data-price]', root);

      function update() {
        var chosen = groups.map(function (g) {
          var c = qs('input:checked', g);
          return c ? c.value : null;
        });

        var v = data.variants.find(function (x) {
          return x.options.every(function (val, i) {
            return val === chosen[i];
          });
        });

        if (!v) {
          if (btn) {
            btn.disabled = true;
            btn.textContent = data.unavailable;
          }
          return;
        }

        if (idInput) idInput.value = v.id;

        if (price) {
          price.innerHTML = v.compare
            ? '<span class="price-now is-sale">' + v.price + '</span> <s class="price-was">' + v.compare + '</s>'
            : '<span class="price-now">' + v.price + '</span>';
        }

        if (btn) {
          btn.disabled = !v.available;
          btn.textContent = v.available ? data.add : data.soldout;
        }

        if (v.slide !== null && v.slide !== undefined) {
          showSlide(root, v.slide);
        }

        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }

      groups.forEach(function (g) {
        if (g.dataset.variantReady === '1') return;
        g.dataset.variantReady = '1';
        g.addEventListener('change', update);
      });
    });
  }

  /* ---------- Related products ---------- */
  function initRecs() {
    qsa('[data-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.dataset.loaded) return;
      el.dataset.loaded = '1';
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-recs]', doc);
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; syncWishlist(); }
      }).catch(function () {});
    });
  }

  /* ---------- Collection filter toggle (mobile) ---------- */
  function initFilters() {
    var t = qs('[data-filter-toggle]');
    var p = qs('[data-filter-panel]');
    if (t && p) t.addEventListener('click', function () { p.classList.toggle('is-open'); });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var KEY = 'giftory_wishlist';
  function getList() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function setList(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} }

  function syncWishlist() {
    var list = getList();
    qsa('[data-wishlist-toggle]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = qs('span', b);
      if (label) label.textContent = on ? 'Saved to wishlist' : 'Add to wishlist';
    });
    qsa('[data-wishlist-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
    });
  }

  function money(cents) {
    try {
      return new Intl.NumberFormat(window.theme.locale, { style: 'currency', currency: window.theme.currency }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function renderWishlistPage() {
    var grid = qs('[data-wishlist-grid]');
    if (!grid) return;
    var list = getList();
    var empty = qs('[data-wishlist-empty]');
    var cta = qs('[data-wishlist-empty-cta]');
    if (empty) empty.hidden = list.length > 0;
    if (cta) cta.hidden = list.length > 0;
    grid.innerHTML = '';
    list.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) {
        if (!r.ok) throw new Error('missing');
        return r.json();
      }).then(function (p) {
        var img = p.featured_image ? '<img class="card-img" loading="lazy" src="' + esc(p.featured_image) + '" alt="' + esc(p.title) + '">' : '';
        var sale = p.compare_at_price > p.price;
        var el = document.createElement('article');
        el.className = 'card';
        el.innerHTML =
          '<div class="card-media"><a class="card-link" href="' + esc(p.url) + '" tabindex="-1">' + img + '</a>' +
          '<button type="button" class="wish-btn is-active" data-wishlist-toggle data-handle="' + esc(p.handle) + '" aria-label="Remove from wishlist" aria-pressed="true">' +
          '<svg class="icon" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 20s-7-4.4-9-9.2C1.8 7.2 4 4 7.2 4c1.9 0 3.3 1 4.8 3 1.5-2 2.9-3 4.8-3C20 4 22.2 7.2 21 10.8 19 15.6 12 20 12 20Z"/></svg></button></div>' +
          '<a class="card-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="price"><span class="price-now' + (sale ? ' is-sale' : '') + '">' + money(p.price) + '</span>' +
          (sale ? ' <s class="price-was">' + money(p.compare_at_price) + '</s>' : '') + '</div>';
        grid.appendChild(el);
      }).catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    var list = getList();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1); else list.push(handle);
    setList(list);
    syncWishlist();
    if (qs('[data-wishlist-grid]') && i > -1) {
      var card = btn.closest('.card');
      if (card) card.remove();
      var empty = qs('[data-wishlist-empty]');
      var cta = qs('[data-wishlist-empty-cta]');
      if (list.length === 0) { if (empty) empty.hidden = false; if (cta) cta.hidden = false; }
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
     initDrawer();
    initTabs();
    initProduct();
    initRecs();
    initFilters();
    syncWishlist();
    renderWishlistPage();

    initProduct();
initGalleryControls();
  });

  /* Re-init in the theme editor when sections reload */
  document.addEventListener('shopify:section:load', function () {
     initDrawer();
    initTabs();
    initProduct();
    initRecs();
    initFilters();
    syncWishlist();
    renderWishlistPage();
    initProduct();
initGalleryControls();
  });
})();
